import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/landing/pages/landing-page/landing-page').then((m) => m.LandingPage),
  },
  {
    path: 'news',
    loadComponent: () =>
      import('./features/landing/pages/news-page/news-page').then((m) => m.NewsPage),
  },
  {
    path: 'news/:id',
    loadComponent: () =>
      import('./features/landing/pages/news-detail-page/news-detail-page').then(
        (m) => m.NewsDetailPage,
      ),
  },
  {
    path: 'news/:index/detail/:id',
    loadComponent: () =>
      import('./features/landing/pages/news-detail-page/news-detail-page').then(
        (m) => m.NewsDetailPage,
      ),
  },
  {
    path: 'news/search/:query',
    loadComponent: () =>
      import('./features/landing/pages/news-search-page/news-search-page').then(
        (m) => m.NewsSearchPage,
      ),
  },
  // about
  {
    path: 'about',
    loadComponent: () =>
      import('./features/landing/pages/about-page/about-page').then((m) => m.AboutPage),
  },
  // events
  {
    path: 'events',
    loadComponent: () =>
      import('./features/landing/pages/events-page/events-page').then((m) => m.EventsPage),
  },
  {
    path: 'events/details/:eventId',
    loadComponent: () =>
      import('./features/landing/pages/event-details-page/event-details-page').then(
        (m) => m.EventDetailsPage,
      ),
  },
  {
    path: 'events/search', // query params: ?query=...
    loadComponent: () =>
      import('./features/landing/pages/events-search-page/events-search-page').then(
        (m) => m.EventsSearchPage,
      ),
  },
  // advisors
  {
    path: 'advisors',
    loadComponent: () =>
      import('./features/landing/pages/advisors-page/advisors-page').then((m) => m.AdvisorsPage),
  },
  {
    path: 'advisors/:type',
    loadComponent: () =>
      import('./features/landing/pages/advisors-page/advisors-page').then((m) => m.AdvisorsPage),
  },
  {
    path: 'advisors/:id/detail',
    loadComponent: () =>
      import('./features/landing/pages/advisor-detail-page/advisor-detail-page').then(
        (m) => m.AdvisorDetailPage,
      ),
  },
  {
    path: 'advisors/:id/appointment',
    loadComponent: () =>
      import('./features/landing/pages/advisor-appointment-page/advisor-appointment-page').then(
        (m) => m.AdvisorAppointmentPage,
      ),
  },
  // contact
  {
    path: 'contact',
    loadComponent: () =>
      import('./features/landing/pages/contact-page/contact-page').then((m) => m.ContactPage),
  },
  // resources
  {
    path: 'resources',
    loadComponent: () =>
      import('./features/landing/pages/resources-page/resources-page').then((m) => m.ResourcesPage),
  },
  // suppliers
  {
    path: 'suppliers',
    loadComponent: () =>
      import('./features/landing/pages/suppliers-page/suppliers-page').then((m) => m.SuppliersPage),
  },
  {
    path: 'suppliers/:supplierId/detail',
    loadComponent: () =>
      import('./features/landing/pages/suppliers-details-page/suppliers-details-page').then(
        (m) => m.SuppliersDetailsPage,
      ),
  },

  // auth routes
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  // user routes
  {
    path: 'user',
    loadChildren: () => import('./features/user/user.routes').then((m) => m.USER_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'policy-privacy',
    loadComponent: () =>
      import('./features/landing/pages/policy-privacy-page/policy-privacy-page').then(
        (m) => m.PolicyPrivacyPage,
      ),
  },
  {
    path: 'policy-privacy/:planId',
    loadComponent: () =>
      import('./features/landing/pages/policy-privacy-page/policy-privacy-page').then(
        (m) => m.PolicyPrivacyPage,
      ),
  },
  // satisfaction form
  {
    path: 'client/satisfaction/:satisfactionFormId',
    loadComponent: () =>
      import('./features/landing/pages/satisfaction-form-page/satisfaction-form-page').then(
        (m) => m.SatisfactionFormPage,
      ),
  },
  // cart routes
  {
    path: 'cart/:planId/:planType',
    loadComponent: () =>
      import('./features/landing/pages/cart-page/cart-page').then((m) => m.CartPage),
  },
  // checkout routes
  {
    path: 'checkout/:planId/:planType',
    loadComponent: () =>
      import('./features/landing/pages/checkout-page/checkout-page').then((m) => m.CheckoutPage),
  },
];
